// 对axios的一次封装
import axio from 'axios'
import store from '../store'
import router from '@/router'
import Vue from 'vue'
import aes from '@/utils/encrypt.js';
import createSign from '@/utils/sign.js';
const isOpenEncrypt = true;
let baseApi = '/api'
import diffReq from "./diffReq.js"
if (process.env.NODE_ENV == 'development') {
  baseApi = '/api'
} else {
  baseApi = '/cps_api'
}
//不用加密的接口
let encryptWhiteList = [
  '/user/upload_img',
  '/user/feedback',
];
const axios = axio.create({
  baseURL: baseApi,
  timeout: 30000
})
// 请求拦截器，实现token的统一添加；
axios.interceptors.request.use(
  config => {
    //    if (store.state.token) {
    //     config.headers.accessToken = store.state.token
    //    }
    let token = localStorage.getItem('tg_token') || '11'
    let postData = {
      token: token,
      ...config.data
    }
    let requestData = {}
    if (isOpenEncrypt && !encryptWhiteList.includes(config.url)) {
      postData['sign'] = createSign.createSign(postData);
      //AES加密
      postData = aes.encrypt(postData);
      requestData = {
        request_params: postData
      }
    } else {
      requestData = postData
    }
    config.data = requestData

    return config
  }, err => {
    return Promise.reject(err)
  })

axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误

    let codeArr = [1001]
    let urlList = ['/bhcoin/user_recharge_submit', '/admin_function/all_users',
      '/admin_function/all_games', '/user_recharge_discount',
      '/admin_function/get_grant_order_num', '/user/oauth_login',
      '/user/bindWeiXin',
      '/user/realauth',
      '/admin_function/grant_submit',
      '/admin_function/promote_ptb_grant',
      '/admin_function/promote_level_list',
      '/pay/ptb_recharge',
      '/pay/recharge_user_ptb',
      '/user/gameMonthSubsidyBatchReceive',
      '/user/login',
      '/user/phone_login_get_list',
      '/user/check_register_page',
      'userpromote_bdcard_set'
    ]
    if (isOpenEncrypt && !encryptWhiteList.includes(response.config.url)) {
      //解密
      const {
        response_params
      } = response.data
      if (response_params && response_params != '') {
        let res = aes.decrypt(response_params);
        response.data.data = JSON.parse(res);
      } else {
        response.data.data = []
      }
    }

    if (response.data.code == 0 && response.config.url != '/user/check_register_page') {
      Vue.prototype.$notify.error({
        title: '错误',
        message: response.data.msg
      });
      return Promise.resolve(response.data)
    }
    if (urlList.includes(response.config.url)) {
      return Promise.resolve(response.data)
    }
    if (response.status === 200) {
      if (response.data.code == 200) {
        if (store.state.isErr == 1) {
          store.dispatch('errRequest', 0);
        }
        return Promise.resolve(response.data)
      } else if (codeArr.includes(response.data.code)) {

        localStorage.removeItem('tg_token')
        let adminUser = localStorage.getItem('adminUser')
        if (adminUser) {
          localStorage.removeItem('adminUser')
        }
        if (router.currentRoute.name != 'BoxRegister') {
          router.push({
            name: 'login'
          }).catch(() => {})
        }

        if (store.state.isErr == 0) {
          Vue.prototype.$notify.error({
            title: '错误',
            message: response.data.msg
          });
        }
        store.dispatch('errRequest', 1);
        return Promise.reject(new Error(response.msg || 'Error'))

      } else {
        Vue.prototype.$notify.error({
          title: '错误',
          message: response.data.msg
        });
        return Promise.reject(new Error(response.msg || 'Error'))

      }

    } else {
      return Promise.reject(new Error(response.msg || 'Error'))
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    // console.log(error)
    if (error.request.status) {
      switch (error.request.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/login'
          }).catch(() => {})
          break
          // 403 token过期
          // 登录过期对用户进行提示
          // 清除本地token和清空vuex中token对象
          // 跳转登录页面
        case 500:
          Vue.prototype.$notify({
            title: '错误',
            message: '服务端异常',
            type: 'error'
          });
          break
        case 6001:
          Vue.prototype.$notify({
            title: '警告',
            message: '登录过期，请重新登录',
            type: 'warning'
          });
          // 清除token
          //   removeItem('user')
          //   store.commit('setUser', null)
          //   store.commit('setToken', '')
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login'
            }).catch(() => {})
          }, 1000)
          break
          // 404请求不存在
        case 404:
          Vue.prototype.error({
            title: '错误',
            message: "网络请求不存在"
          });
          break
          // 其他错误，直接抛出错误提示
        default:

          Vue.prototype.error({
            title: '错误',
            message: error.response.data.message
          });
      }
    }
    return Promise.reject(error.response.data.message)
  })
// export default uploadUrl
export default axios
// export default {
//   axios,
//   uploadUrl
// }



// WEBPACK FOOTER //
// ./src/utils/request.js